import NavBar from 'NavBar/NavBar';

export default NavBar;